import type { Integration } from '../types/integration.types'

export const integrations: Integration[] = [
  {
    id: 'stripe',
    name: 'Stripe',
    category: ['billing', 'payments'],
    description:
      "Leverage Stripe to bill customers, collect payemnts, according to the pricing model that's defined in Coobird",
    logo: 'https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/stripe.svg',
    logoAlt: 'Stripe logo',
    status: 'not-integrated',
    connectUrl: '/developers/integrations/stripe/connect',
    docsUrl: 'https://docs.stripe.com',
  },
]
